{
  "imddb-header": {
    "navbar": {
      "leak": "Leak to us",
      "support": "Soutenez nous",
      "follow": "Suivez l'ICIJ"
    }
  },
  "app-header": {
    "navbar": {
      "investigations": "Enquêtes",
      "leak": "Contact securisé",
      "support": "Soutenez nous",
      "follow": "Suivez l'ICIJ"
    }
  },
  "generic-header": {
    "navbar": {
      "investigations": "Enquêtes",
      "leak": "Contact securisé",
      "support": "Soutenez nous",
      "follow": "Suivez l'ICIJ"
    }
  },
  "embeddable-footer": {
    "share": "Partager"
  },
  "embed-form": {
    "heading": "Intégrer sur votre site",
    "introduction": "Copiez le code ci-dessous pour l'intégrer à votre site.",
    "responsive-optin": "Hauteur dynamique",
    "copy": "Copier"
  },
  "follow-us-popover": {
    "heading": "Suivez nous"
  },
  "app-footer": {
    "investigations": "Enquêtes",
    "follow-us": "Suivez nous",
    "all-rights": "Tous droits réservés",
    "version": "Version {version}"
  },
  "generic-footer": {
    "investigations": "Enquêtes",
    "follow-us": "Suivez nous",
    "all-rights": "Tous droits réservés",
    "version": "Version {version}"
  },
  "donate-form": {
    "support": "Soutenez nous",
    "introduction": "ICIJ’s investigations are supported by readers like you. Help keep our databases free and open to the public by joining our <strong><a target=\"_blank\" href=\"https://icij.org/donate\">ICIJ Insiders</a></strong> community.",
    "join-heading": "Won't you join us today?",
    "label": "I would like to donate",
    "frequency": {
      "monthly": "Monthly",
      "yearly": "Yearly",
      "onetime": "One time"
    },
    "result": {
      "sentence": "With this donation, you are <strong>changing the %{target}</strong>.",
      "conversation": "conversation",
      "rules": "rules",
      "world": "world"
    },
    "suggesteddonation": {
      "conversation": {
        "monthly": 10,
        "yearly": 25,
        "onetime": 50
      },
      "rules": {
        "monthly": 25,
        "yearly": 180,
        "onetime": 180
      },
      "world": {
        "monthly": 100,
        "yearly": 600,
        "onetime": 600
      }
    },
    "submit": "Donate now",
    "benefits": {
      "heading": "ICIJ Insiders benefits",
      "introduction": "Your monthly or annual donation will give you the following benefits.",
      "more": "More about donations",
      "list": [
        "Invitation to exclusive chat with ICIJ staff about our latest major project after publication",
        "Opportunity to submit your questions to ICIJ staff. Several questions will be answered in our quarterly ICIJ Insider newsletter",
        "Sneak previews behind the scenes of ICIJ’s work (monthly)",
        "ICIJ Insider Newsletter (quarterly)",
        "ICIJ’s Weekly Update"
      ],
      "impacts": {
        "conversation": {
          "level": "conversation",
          "heading": "Change the conversation",
          "highlight": "$1-$179/Year <span class='monthly'>or $1-$14/Month</span>"
        },
        "rules": {
          "level": "rules",
          "heading": "Change the rules",
          "highlight": "$180-$599/Year <span class='monthly'>or $15-$49/Month</span>"
        },
        "world": {
          "level": "world",
          "heading": "Change the world",
          "highlight": "$600+/Year <span class='monthly'>or $50+/Month</span>"
        }
      }
    }
  },
  "sign-up-form": {
    "label": "Recevez nos articles par email",
    "placeholder": "Adresse email",
    "submit": "S'abonner"
  },
  "haptic-copy": {
    "label": "Copier",
    "tooltip": {
      "succeed": "Copié!"
    }
  },
  "tiny-pagination": {
    "page": "Page",
    "aria": "Allez à la page",
    "total": "sur {numberOfPages}",
    "previous": "Page suivante",
    "next": "Page précédente"
  }
}
